import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useMutation, useQueryClient } from 'react-query';
import { AircraftsAPI } from '../services/aircrafts.ts';
import { parseCurrency, formatCurrencyInput } from '../utils/currency.ts';
import { ArrowLeftIcon, TagIcon } from '@heroicons/react/24/outline';

const AircraftSale: React.FC = () => {
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();
  const queryClient = useQueryClient();

  const [soldDate, setSoldDate] = useState<string>(new Date().toISOString().split('T')[0]);
  const [sellingPriceDisplay, setSellingPriceDisplay] = useState<string>('');
  const [error, setError] = useState<string>('');

  const mutation = useMutation(
    async () => {
      const sellingPrice = parseCurrency(sellingPriceDisplay);
      if (!sellingPrice) throw new Error('Preço de venda inválido');
      return AircraftsAPI.sell(Number(id), { sellingPrice, soldDate });
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['aircraft', id]);
        queryClient.invalidateQueries(['aircrafts']);
        navigate(`/aircrafts/${id}`);
      },
      onError: (err: any) => {
        setError(err?.message || 'Erro ao registrar venda');
      },
    }
  );

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 py-8">
      <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mb-8">
          <button onClick={() => navigate(`/aircrafts/${id}`)} className="flex items-center text-gray-600 hover:text-gray-900 mb-4 transition-colors">
            <ArrowLeftIcon className="h-5 w-5 mr-2" /> Voltar para Detalhes
          </button>
          <h1 className="text-3xl font-bold text-gray-900 flex items-center">
            <TagIcon className="h-8 w-8 mr-3 text-green-600" /> Registrar Venda da Aeronave
          </h1>
        </div>

        <form onSubmit={e => { e.preventDefault(); mutation.mutate(); }} className="space-y-6 bg-white rounded-xl shadow-lg p-6">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Data de Venda</label>
            <input type="date" value={soldDate} onChange={e => setSoldDate(e.target.value)} className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent border-gray-300" />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Preço de Venda</label>
            <input
              type="text"
              value={sellingPriceDisplay}
              onChange={e => setSellingPriceDisplay(e.target.value)}
              onBlur={e => {
                const raw = e.target.value;
                const n = parseCurrency(raw);
                setSellingPriceDisplay(raw.trim() ? formatCurrencyInput(n) : '');
              }}
              className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent border-gray-300"
              placeholder="0,00"
              inputMode="decimal"
            />
          </div>
          {error && <div className="text-red-600 text-sm">{error}</div>}
          <div className="flex justify-end">
            <button type="submit" className="bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded-lg transition-colors">Confirmar Venda</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AircraftSale;